import { GetAccountsResponse } from '@iwoca/lapi-client/edge';
import { Pill } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const LoanStatusPill = ({
    loanStatus
}: {
    loanStatus: GetAccountsResponse['data']['accounts'][0]['loan_status'];
}) => {
    switch (loanStatus) {
        case 'ongoing':
        case 'duetoday':
            return (
                <div className="mx-xs">
                    <Pill variant="green" size="small">
                        <FormattedMessage
                            id="_.dashboard.loan_status.ongoing"
                            defaultMessage="Ongoing"
                        />
                    </Pill>
                </div>
            );
        case 'overdue':
            return (
                <div className="mx-xs">
                    <Pill variant="red" size="small">
                        <FormattedMessage
                            id="_.dashboard.loan_status.overdue"
                            defaultMessage="Overdue"
                        />
                    </Pill>
                </div>
            );
        case 'ended':
            return (
                <div className="mx-xs">
                    <Pill variant="london" size="small">
                        <FormattedMessage
                            id="_.dashboard.loan_status.ended"
                            defaultMessage="Ended"
                        />
                    </Pill>
                </div>
            );

        default:
            return null;
    }
};
